import React from "react";

export default function RouteLoading() {
  return (
    <div style={{ minHeight: "50vh", display: "grid", placeItems: "center", color: "#ffcc00" }}>
      <p>Loading account...</p>
    </div>
  );
}
